<template>
  <v-app>
    <v-toolbar
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            color="light-blue darken-3"
            dark
            fixed
            app>
      <v-toolbar-title class="ml-0 pl-3">
        <span>[edoc].cloud</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <v-layout>
          <v-flex v-if="document">
            <v-toolbar class="elevation-1">
              <h3 v-if="document">Файл: {{ document.name }}</h3>
              <v-spacer />
              <div v-if="document">
                <v-btn small @click.native="sign_dialog = true">
                  Подписать
                  <v-icon right small>mdi-lead-pencil</v-icon>
                </v-btn>
              </div>
            </v-toolbar>
            <v-card>
              <div v-if="loading"></div>
              <v-layout row v-else>
                <v-flex xs12 lg8 xl8>
                  <DocumentViewer v-if="document" :document="document" :is_shared="true" />
                </v-flex>
                <v-flex pa-2 lg4 xl4>
                  <v-btn v-if="document" :href="document.original_url" block>
                    Скачать оригинал
                  </v-btn>
                  <v-btn v-if="document && document.signs.length > 0" :href="document.archive_url" block>
                    Скачать архив с подписями
                  </v-btn>
                  <h3>Подписи:</h3>
                  <v-card class="mb-2" v-for="sign in document.signs" :key="'sign_'+sign.drfo+sign.edrpou">
                    <v-card-title>
                      <div>
                        <span><b>Организация:</b> {{ sign.organization }}</span><br>
                        <b>ФИО:</b> {{ sign.name }}<br>
                        <template v-if="sign.edrpou"><b>ЕДРПОУ:</b> {{ sign.edrpou }}<br></template>
                        <template v-if="sign.drfo"><b>ДРФО:</b> {{ sign.drfo }}<br></template>
                        <template v-if="sign.title"><b>Должность:</b> {{ sign.title }}<br></template>
                        <b>Дата/Время подписи:</b> {{ sign.created_at | date }}<br>
                        <b>Файл подписи: </b> <a :href="sign.url">Скачать</a>
                      </div>
                    </v-card-title>
                  </v-card>
                  <p v-if="document.signs.length == 0">Выбранный документ не имеет ЭЦП.</p>
                </v-flex>
              </v-layout>
            </v-card>
            <DocumentSignDialog v-model="sign_dialog" :document="document" :is_shared="true" @close="sign_dialog = false" @done="fetchData()" />
          </v-flex>
          <v-flex v-else>
            <h3>Документ не найден или автор закрыл доступ.</h3>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex class="grey--text mt-3">
            <b>
              Безкоштовний сервіс обміну eлeктронними документами Edoc.Cloud. <br>
              Для отримання більших можливостей перейдіть до реєстрації за наступним <a href="/reg" target="_blank">посиланням</a>
            </b>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import DocumentSignDialog from '@/components/DocumentSignDialog'
import DocumentViewer from '@/components/DocumentViewer'


export default {
  components: {
    DocumentSignDialog,
    DocumentViewer
  },
  data () {
    return {
      document: null,
      sign_dialog: false,
      loading: false
    }
  },
  methods: {
    fetchData() {
      this.$store.dispatch('getDocumentById', this.$route.params.document_id)
        .then((response) => {
          this.document = response.data
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  created () {
    this.loading = true
    this.$store.dispatch('getDocumentById', this.$route.params.document_id)
      .then((response) => {
        this.document = response.data
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>